export enum SeparatorKinds {
  None = 0,
  MiddlePoint = 1,
  NewLine = 2,
  Comma = 3,
  WideComma = 4,
  WideSpace = 5,
}
